import Base from "./base";

export default class Search extends Base {
  constructor(params = {}) {
    super(params);
  }
}
